import { AfterViewInit, Component, HostBinding, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';

import { DashboardControlsComponent } from '../dashboard-controls/dashboard-controls.component';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { AlarmeService } from 'src/app/_services/http/alarme.service';
import { KafkaHealthService } from 'src/app/_services/http/kafka-health.service';
import { SessionEditionService } from 'src/app/_services/http/session-edition.service';
import { DashboardService } from '../dashboard/dashboard.service';
import { MainStoreState } from 'src/app/_store/mainStoreState';
import { VersionService } from 'src/app/_services/http/version.service';
import { getCurrentUser } from 'src/app/_store/AccountStore/account.store';


@Component({
  selector: 'app-dashboard-container',
  templateUrl: './dashboard-container.component.html',
  styleUrls: ['./dashboard-container.component.scss']
})
export class DashboardContainerComponent implements OnInit, AfterViewInit {

  title = 'SAGT';

  @ViewChild('dashboardControlsComponent')
  private dashboardControlsComponent!: DashboardControlsComponent;
  @ViewChild('dashboardComponent')
  private dashboardComponent!: DashboardComponent;

  @HostBinding('style.grid-template-rows')
  gridTemplateRows = '64px 1fr';

  version$ = this.versionService.get();
  displayFooter = 'flex';

  constructor(
    private readonly alarmeService: AlarmeService,
    private readonly kafkaService: KafkaHealthService,
    private readonly sessionService: SessionEditionService,
    private readonly dashboardService: DashboardService,    
    private readonly store: Store<MainStoreState>,
    private readonly versionService: VersionService
  ) {}

  ngOnInit(): void {
    this.store.select(getCurrentUser).subscribe((user) => {
      if (user) {
        this.alarmeService.refreshHubConnection().then(() => {});
        this.kafkaService.refreshHubConnection().then(() => {});
        this.sessionService.refreshHubConnection().then(() => {});

        setTimeout(() => {
          if (!this.dashboardService.isPopup()) {
            const result = this.dashboardService.loadDashboardInStorage();

            if(!result){
              if (this.dashboardService.isWidgetOpen('MapVecComponent')) {
                this.dashboardService.focusWidget('MapVecComponent');
              } else {
                this.dashboardService.openWidget('MapVecComponent');
              }
            }
          }
        }, 1000);
      }
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.dashboardComponent.initialize();
      this.dashboardControlsComponent.initialize();

      this.dashboardService.shouldDisplayControls$.subscribe((x) => {
        if (!x) {
          this.gridTemplateRows = '0 1fr';
          this.displayFooter = 'none';
        }
      });
    }, 0);
  }
}
